<template>
<div>
<table class="vs-table vs-table--tbody-table striped-table permit-table" :style="{overflow:'auto',height:tableHeight+'vh'}" id="loading-table-1">
        <thead>
        <tr class="tr-values vs-table--tr tr-table-state-null">
            <th :style="{width:'15%'}" class="qb-sticky"><b>{{$t('client')}}</b></th>
            <th :style="{width:'15%'}" class="qb-sticky"><b>{{$t('building_number')}}</b></th>
            <th :style="{width:'30%'}" class="qb-sticky"><b>{{$t('title')}}</b></th>
            <th :style="{width:'17%'}" class="qb-sticky"><b>{{$t('status')}} {{$t('and')}} {{$t('expiration')}}</b></th>
            <th :style="{width:'33%'}" class="qb-sticky"><b>{{$t('comments')}}</b></th>
            <th :style="{width:'33%'}" class="qb-sticky"><b></b></th>
        </tr>
        </thead>

        <tbody :style="{overflow:'auto'}">
        <template v-for="(ehs, index) in users">
            <tr class="tr-body tr-values vs-table--tr tr-table-state-null" :key="index">
            <td class="text-left"  :title="ehs.client_name" style="width='15%'">
                {{ehs.client_short_name}}
            </td>
            <td class="text-left comment-truncate" style="width='15%'">
                {{ehs.building_number}}
            </td>
            <td class="text-left comment-truncate" style="width='10%'">
                {{ehs.name}}
                    <br>
                    <span class="material-icons sm blue-info" style="font-size:8px">
                            lens
                    </span>
                    <span class="text-left comment-truncate" style="font-size='9px'">
                    {{  ehs.category_name}}
                    </span>
            </td>
            <td class="text-center">
                <vs-chip class="label-status" :color="ehs.status_color">{{ehs.status_name}}<br>{{ehs.date_expiration}}</vs-chip>
            </td>
            <td class="text-left comment-truncate" style="width='15%'">
                {{  ehs.comment}}
            </td>
            <td class="text-left comment-truncate" style="width='15%'">
                <action-icon icon="ArrowRightCircleIcon" :tooltip="$t('go')" @click="redirectEhs(ehs)" />
            </td>
            </tr>
        </template>
        </tbody>
    </table>
</div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
export default {
  props:['users','tableHeight'],
  components:{
    ActionIcon
  },
   methods:{
    redirectEhs(ehs){
      this.$store.dispatch('setFilter',{ item:ehs });
      this.$router.push({ path:'/ehs' })
    }
  }
}

</script>

<style lang="scss">
 th, td {
    font-size: 0.9rem;
  }

  .smallFont{
      font-size: 8px;
  }

  .bg-color{
      background-color:#86E6FA
  }

  .sm{
      font-size: 10px;
  }

  .blue-info{
      color:#14AFDC
  }

  .label-status { max-width: 9rem; min-width: 2rem;  color: white; text-align: center; border-radius: .3em; }

  .content-center{ text-align: center; }
  

 /*  .striped-table table{
      table-layout: fixed;
      overflow: auto;
      word-wrap: break-word;
      border-collapse:collapse;
  } */

  

.comment-truncate{
    overflow-wrap: break-word;
}
</style>